<section class="hm-story">
  <div class="hm-story-img" [style.backgroundImage]="'url(' + feature.imageUrl + ')'"></div>
  <div class="hm-story-inner">
    <p class="hm-eyebrow">{{ feature.eyebrow }}</p>
    <h2 class="hm-story-title">{{ feature.title }}</h2>
    <p class="hm-story-standfirst">{{ feature.standfirst }}</p>
    <a class="hm-more" [routerLink]="feature.targetUrl"
      >{{ feature.ctaLabel }} <span class="arw" aria-hidden="true">→</span></a
    >
  </div>
</section>
